import React from "react";
import { PageWrapper } from "@/components/PageWrapper";
import NotFound from "@/components/NotFound";

const NoPage = () => (
  <PageWrapper>
    <NotFound />
  </PageWrapper>
);

export default NoPage;
